'use client'
import EventsOutletCard from '@/app/[lng]/components/EventsOutlet/EventsOutletCard'
import { useGetEventSearchQuery } from '@/app/globalRedux/api/searchSlice'
import { setEventPageNo } from '@/app/globalRedux/filter/eventFilter'
import { RootState } from '@/app/globalRedux/store'
import { AdBannerScheduleType } from '@/app/types/adType'
import { EventItem, EventSearchResponse } from '@/app/types/eventType'
import LimitPagination from '@/components/LimitPagination'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InBetweenAds from '../../search/(AdComponent)/InBetweenAds'
import EmptyResult from '../../search/EmptyResult'
import CustomErrorBoundary from '@/app/[lng]/ErrorBoundary'
import HomeSalesOfferSkeleton from '@/app/[lng]/components/Skeletons/HomeSalesOfferSkeleton'

const adInterval = 3

const EventList = ({ adList }: { adList?: AdBannerScheduleType[] }) => {
  const dispatch = useDispatch()
  const [adsData, setAdsData] = useState<AdBannerScheduleType[]>([])
  const eventPageNo = useSelector(
    (state: RootState) => state.eventFilter.pageNo
  )

  const eventFilter = useSelector((state: RootState) => state.eventFilter)

  const { data: eventsData, isFetching: isEventsFetching } =
    useGetEventSearchQuery<{
      data: EventSearchResponse
      isFetching: boolean
    }>({
      eventFilter: eventFilter,
    })

  useEffect(() => {
    if (adList) {
      const adFilter5 =
        adList.filter((ad) => ad.ad_position.name === 'Ad Position 5')[0] ?? {}
      const adFilter6 =
        adList.filter((ad) => ad.ad_position.name === 'Ad Position 6')[0] ?? {}
      const adFilter7 =
        adList.filter((ad) => ad.ad_position.name === 'Ad Position 7')[0] ?? {}

      const adsData = [adFilter5, adFilter6, adFilter7]

      setAdsData(adsData)
    }
  }, [adList])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [eventFilter?.pageNo])

  return (
    <>
      {isEventsFetching ? (
        <div className="gap-2 flex flex-col">
          {Array.from({ length: 10 }, (_, index) => (
            <HomeSalesOfferSkeleton key={`skeleton_${index}`} />
          ))}
        </div>
      ) : eventsData?.events?.length > 0 ? (
        <div className="flex flex-col gap-4 my-3">
          {eventsData.events.map((event: EventItem, index: number) => (
            <React.Fragment key={`event_${event.id}_${index}`}>
              <CustomErrorBoundary>
                <div className="cursor-pointer overflow-hidden relative border p-2 rounded-sm border-lightgreen_border mobile:grid-cols-4 mobile:gap-[20px]">
                  <EventsOutletCard eventData={event} />
                </div>
              </CustomErrorBoundary>

              {(index + 1) % adInterval === 0 && (
                <div className="flex flex-col gap-4 ">
                  <InBetweenAds
                    index={index}
                    adsData={
                      adsData[Math.floor(index / adInterval) % adsData?.length]
                    }
                  />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      ) : (
        <EmptyResult searchTerm={eventFilter?.searchTerm ?? ''} />
      )}

      {eventsData?.events?.length > 0 && (
        <div className="mt-[35px] border-t-2 border-t-[#e6e6e6] border-solid mobile:mt-[10px]">
          <LimitPagination
            currentPage={eventPageNo}
            pageCount={Math.ceil((eventsData.count ?? 1) / 10)}
            visiblePages={5}
            onPageChange={(page) => dispatch(setEventPageNo(page))}
          />
        </div>
      )}
    </>
  )
}

export default EventList
